module.exports = __webpack_public_path__ + "static/deals-for-you-mobile-3fb8fbfa20c08913bb1868f30ef14da0.png";